import { Injectable } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {ToolsService} from "../tools/tools.service";
import {Question} from "../../models/question.model";
import {Observable} from "rxjs";
import {AuthService} from "../auth/auth.service";

@Injectable({
  providedIn: 'root'
})
export class SurveyService {

  constructor(
    private http: HttpClient,
    private toolSrv: ToolsService,
    private authSrv: AuthService
  ) { }

  startSurvey(subdomain: string | null): Observable<string> {    
    const baseUrl = `${this.toolSrv.getApiEndpoint()}survey/start`;
    const url = subdomain && subdomain !== 'app' ? `${baseUrl}/${subdomain}` : baseUrl;

    return this.http.get<string>(url);
  }

  storeSurvey(uniqid: string): void {
    sessionStorage.setItem('survey', uniqid);
  }

  getSurvey(): Observable<any> {
    const survey = sessionStorage.getItem('survey');
    return this.http.get<Question[]>(`${this.toolSrv.getApiEndpoint()}survey/answers/${survey || ''}`)
  }
}
